export default __webpack_public_path__ + "static/media/node.35ab27a2.svg";